import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowLeft from "../assets/icon/svgs/ArrowLeft.svg?react";
import Mail from "../assets/icon/svgs/Mail.svg?react";
import Call from "../assets/icon/svgs/Call.svg?react";
import CallColor from "../assets/icon/svgs/CallColor.svg?react";
import BuildingColor from "../assets/icon/svgs/BuildingColor.svg?react";
import TelegramIcon from "../assets/icon/svgs/Telegram.svg?react";
import WhatsAppIcon from "../assets/icon/svgs/Whatsapp.svg?react";
import SimpleArrow from "../assets/icon/svgs/ArrowSimple.svg?react";
import CrossRight from "../assets/icon/svgs/CrossRight.svg?react";
import File from "../assets/icon/svgs/File.svg?react";
import TabBar from "@/components/tabBar/TabBar";
import { Loader } from "@/assets/icon/loader";
import HeaderCommon from "@/components/header/HeaderCommon";
import { Button } from "@/components/ui/button";
import BillsService, {
  EmergencyInfo,
} from "@/api-client/api/services/billsService/billsService";
import { useTranslation } from "react-i18next";
import Chip, { ChipStatusEnum } from "@/components/customComponents/Chip";
import HouseManagerApi, {
  GetRepairWorksResponse,
  RepairWork,
} from "@/api-client/api/services/houseManager/houseManager";
import Pagination from "@/components/customComponents/Pagination";
import SelectTab from "@/components/selectTab/SelectTab";
import { HOME_ADDRESS_ROUTE } from "@/lib/constants/routes";

const AddressPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id, address } = useParams();
  const [loading, setLoading] = useState(false);
  const [emergencyInfo, setEmergencyInfo] = useState<EmergencyInfo>();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const apartment_id = searchParams.get("apartment_id");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [repairWorks, setRepairWorks] = useState<GetRepairWorksResponse>();
  const [year, setYear] = useState<string | undefined>(undefined);
  const [status, setStatus] = useState<string | undefined>(undefined);

  const yearOptions = [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
  ];
  const statusOptions = [
    { value: "planned", label: t("planned") },
    { value: "in_progress", label: t("in_progress") },
    { value: "done", label: t("done") },
    { value: "canceled", label: t("canceled") },
  ];

  const getRepairWorks = async () => {
    try {
      const response = await HouseManagerApi.getRepairWorks({
        building_id: id || undefined,
        page: page,
        page_size: pageSize,
        year: year,
        status: status,
      });
      setRepairWorks(response);
      setTotalPages(response.pagination.total_pages);
    } catch (error) {
      console.log(error);
    }
  };
  const options = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const formatted = (dateStr: string) => {
    const date = new Date(dateStr);
    //@ts-expect-error options is not defined
    const datePart = new Intl.DateTimeFormat("en-US", options)
      .format(date)
      .replace(",", "");
    const timePart = date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" AM", "")
      .replace(" PM", "");
    return `${datePart}, at ${timePart}`;
  };

  const getEmergencyInfo = async () => {
    setLoading(true);
    try {
      const response = await BillsService.getEmergencyInfo(Number(id));
      setEmergencyInfo(response);
    } catch (error) {
      console.error("Error fetching emergency info:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getEmergencyInfo();
    }
  }, [id]);

  useEffect(() => {
    getRepairWorks();
  }, [id, page, pageSize, year, status]);

  const ststusStyle = (status: string) => {
    switch (status) {
      case "planned":
        return ChipStatusEnum.BLUE;
      case "done":
        return ChipStatusEnum.GREY;
      case "canceled":
        return ChipStatusEnum.RED;
      case "in_progress":
        return ChipStatusEnum.BLUE;
      default:
        return ChipStatusEnum.GREY;
    }
  };

  const ProjectItem = ({
    item,
    index,
  }: {
    item: RepairWork;
    index: number;
  }) => {
    const [expandedItems, setExpandedItems] = useState<number[]>([]);

    const toggleExpand = (index: number) => {
      setExpandedItems((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    };
    return (
      <>
        <div className="flex flex-col gap-8">
          <div>
            <div className="flex flex-col gap-2">
              <div className="flex justify-between">
                <div className="flex flex-row gap-4 items-start">
                  <Chip
                    status={ststusStyle(item.status)}
                    text={t(`${item.status}`)}
                  />
                  <span className="text-[15px] text-[#00000080] font-medium">
                    {formatted(item.created_at)}
                  </span>
                </div>
              </div>
              <span className="text-[28px] font-medium leading-[130%]">
                {item.title}
              </span>
            </div>
            <div
              className={`flex flex-col w-[50%] gap-4 overflow-hidden ${
                expandedItems.includes(index) ? "max-h-full" : "max-h-[267px]"
              }`}
            >
              <div
                className={` rich-text-view `}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
              <div className="flex flex-wrap gap-[20px]">
                {item.files.map((file) => {
                  return (
                    <a
                      href={file.pdf}
                      className="flex flex-row gap-2 text-[#0027CB] text-[20px] font-medium items-center"
                    >
                      <File width={24} height={24} />
                      <span>{file.pdf?.split("/").pop()}</span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
          <div>
            <Button
              className="flex flex-row gap-2 leading-[120%] text-[20px] text-[#0027CB] h-fit px-0 items-center"
              variant="link"
              size="sm"
              onClick={() => toggleExpand(index)}
            >
              {expandedItems.includes(index)
                ? t("projects_and_repair_works.read_less")
                : t("projects_and_repair_works.read_more")}
              <SimpleArrow
                width={18}
                height={18}
                className={`transition-transform ${
                  expandedItems.includes(index) ? "" : "rotate-180"
                }`}
              />
            </Button>
          </div>
        </div>
        {repairWorks?.results.length !== index + 1 && (
          <span className="border-b-[1px] border-[#0000001A]" />
        )}
      </>
    );
  };

  return (
    <div className="flex flex-row flex-1 p-4 gap-6">
      <TabBar />
      {loading ? (
        <div className="flex justify-center w-full h-full my-auto">
          <Loader isGrey={true} />
        </div>
      ) : (
        <div className="w-0 flex flex-col flex-1 gap-5">
          <div className="flex justify-between items-center pl-4">
            <div className="flex flex-row items-center gap-2 font-medium text-[20px]">
              <Button
                variant="link"
                size="sm"
                onClick={() => {
                  navigate(`${HOME_ADDRESS_ROUTE}/${apartment_id}`);
                }}
              >
                <ArrowLeft id="arrow_left" />
              </Button>
              <span className="text-[#00000080]">{address}</span> /{" "}
              {t("house_manager.houses_info")}
            </div>
            <HeaderCommon />
          </div>
          <span className="pl-4 text-[24px] font-medium">
            {t("house_manager.houses_info")}
          </span>
          <div className="flex flex-col gap-4">
            <div className="flex flex-row gap-4">
              <div className="flex-1 flex flex-col gap-4 p-4 border-2 border-[#0000001A] rounded-[16px]">
                <div className="flex flex-row gap-2 items-center">
                  <BuildingColor className="w-[32px] h-[32px]" />
                  <span className="text-[20px] font-medium">
                    {t("house_manager.building_information")}
                  </span>
                </div>
                <div className="flex flex-col gap-2">
                  <p className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.information_for_residents")}
                  </p>
                  <div className="flex flex-1 flex-col gap-3 font-medium">
                    <div className="flex flex-row justify-between">
                      <p className="text-[18px] whitespace-pre-line" key={12}>
                        {emergencyInfo?.info
                          ? emergencyInfo?.info
                          : t("no_data")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <p className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.access_codes")}
                  </p>
                  <div className="flex flex-1 flex-col gap-2">
                    {emergencyInfo?.access_codes &&
                    emergencyInfo?.access_codes?.length > 0 ? (
                      emergencyInfo?.access_codes?.map((item, index) => (
                        <>
                          <p className="text-[18px] font-medium" key={index}>
                            {item}
                          </p>
                        </>
                      ))
                    ) : (
                      <p className="text-[18px] font-medium">{t("no_data")}</p>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <p className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.funds_and_debts")}
                  </p>
                  <div className="flex flex-1 flex-col gap-3 font-medium">
                    <>
                      <div className="flex flex-row justify-between">
                        <p className="text-[18px]" key={12}>
                          {emergencyInfo?.service_company_debt ? (
                            <>
                              {emergencyInfo?.service_company_debt}
                              <span className="text-[12px] align-super">
                                {" "}
                                €
                              </span>
                            </>
                          ) : (
                            t("no_data")
                          )}
                        </p>
                        <span className="text-[15px] text-[#00000080]">
                          {t("house_manager.service_company_debt")}
                        </span>
                      </div>
                      <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />

                      <div className="flex flex-row justify-between">
                        <p className="text-[18px]" key={12}>
                          {emergencyInfo?.utility_debt ? (
                            <>
                              {emergencyInfo?.utility_debt}
                              <span className="text-[12px] align-super">
                                {" "}
                                €
                              </span>
                            </>
                          ) : (
                            t("no_data")
                          )}
                        </p>
                        <span className="text-[15px] text-[#00000080]">
                          {t("house_manager.utility_debt")}
                        </span>
                      </div>
                      <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />

                      <div className="flex flex-row justify-between">
                        <p className="text-[18px]" key={12}>
                          {emergencyInfo?.cumulative_fund ? (
                            <>
                              {emergencyInfo?.cumulative_fund}
                              <span className="text-[12px] align-super">
                                {" "}
                                €
                              </span>
                            </>
                          ) : (
                            t("no_data")
                          )}
                        </p>
                        <span className="text-[15px] text-[#00000080]">
                          {t("house_manager.cumulative_fund")}
                        </span>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex flex-col p-4 gap-4 border-2 border-[#0000001A] rounded-[16px]">
                <div className="flex flex-row gap-2 items-center">
                  <CallColor width={32} height={32} />
                  <span className="text-[20px] font-medium">
                    {t("house_manager.contacts_of_service")}
                  </span>
                </div>

                <div className="flex flex-col gap-2">
                  <span className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.house_manager")}
                  </span>

                  <div className="flex flex-row gap-4">
                    <div className="flex-1 flex flex-row gap-2">
                      <span
                        className={`text-[18px] font-medium pt-[10px] leading-[40%]`}
                      >
                        {emergencyInfo?.house_admin_details?.first_name &&
                        emergencyInfo?.house_admin_details?.last_name
                          ? `${emergencyInfo?.house_admin_details?.first_name} ${emergencyInfo?.house_admin_details?.last_name}`
                          : t("no_data")}
                      </span>
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                      <>
                        <div className="flex flex-row items-center justify-between">
                          <div
                            className={`flex flex-row gap-1 items-center ${
                              emergencyInfo?.house_admin_details?.phone_number
                                ? "text-[#0027CB]"
                                : "text-[#00000080]"
                            }`}
                          >
                            <Call width={16} />
                            <span className="text-[12px] font-medium ">
                              {emergencyInfo?.house_admin_details?.phone_number
                                ? emergencyInfo?.house_admin_details
                                    ?.phone_number
                                : t("no_data")}
                            </span>
                          </div>
                          <span className="text-[15px] text-[#00000080]">
                            House manager
                          </span>
                        </div>
                        <div
                          className={`flex flex-row gap-1 items-center ${
                            emergencyInfo?.house_admin_details?.email
                              ? "text-[#0027CB]"
                              : "text-[#00000080]"
                          }`}
                        >
                          <Mail width={16} />
                          <span className="text-[12px] font-medium">
                            {emergencyInfo?.house_admin_details?.email
                              ? emergencyInfo?.house_admin_details?.email
                              : t("no_data")}
                          </span>
                        </div>
                      </>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-[12px] text-[#00000080] font-medium">
                      {t("house_manager.emergency_services")}
                    </p>
                    <div className="flex flex-1 flex-col gap-3 font-medium">
                      <div className="flex flex-row justify-between">
                        <p className="text-[18px] whitespace-pre-line" key={12}>
                          {emergencyInfo?.contacts_info
                            ? emergencyInfo?.contacts_info
                            : t("no_data")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-[13px]">
                    <p className="text-[12px] text-[#00000080] font-medium">
                      {t("house_manager.house_chats")}
                    </p>
                    <>
                      <div className="flex flex-row gap-4 text-[18px] font-medium items-center">
                        <div className="flex-1">Telegram</div>
                        <div className="flex-1 flex flex-row gap-1 items-center">
                          <TelegramIcon width={16} height={16} />
                          <a
                            href={emergencyInfo?.telegram_link}
                            className="text-[12px] text-[#0027CB]"
                          >
                            {emergencyInfo?.telegram_link
                              ? emergencyInfo?.telegram_link
                              : t("no_data")}
                          </a>{" "}
                        </div>
                      </div>
                      <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />
                      <div className="flex flex-row gap-4 text-[18px] font-medium items-center">
                        <div className="flex-1">WhatsApp</div>
                        <div className="flex-1 flex flex-row gap-1 items-center">
                          <WhatsAppIcon width={16} height={16} />
                          <a
                            href={emergencyInfo?.whatsapp_link}
                            className="text-[12px] text-[#0027CB] "
                          >
                            {emergencyInfo?.whatsapp_link
                              ? emergencyInfo?.whatsapp_link
                              : t("no_data")}
                          </a>{" "}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div
              id="title_bills"
              className="flex items-center text-[24px] gap-2 font-medium"
            >
              {t("projects_and_repair_works.projects")}
              <span
                id="all_bills_paid_header"
                className={`px-2 rounded-[20px] text-[#00000080] text-[16px] bg-[#F5F5F5]`}
              >
                {repairWorks?.pagination.total_items}
              </span>
              <Chip
                status={ChipStatusEnum.BLUE}
                text={`${t("projects_and_repair_works.planned")} ${
                  repairWorks?.status_counts.planned
                }`}
              />
              <Chip
                status={ChipStatusEnum.BLUE}
                text={`${t("projects_and_repair_works.in_progress")} ${
                  repairWorks?.status_counts.in_progress
                }`}
              />
              <Chip
                status={ChipStatusEnum.GREY}
                text={`${t("projects_and_repair_works.done")} ${
                  repairWorks?.status_counts.done
                }`}
              />
              <Chip
                status={ChipStatusEnum.RED}
                text={`${t("projects_and_repair_works.canceled")} ${
                  repairWorks?.status_counts.canceled
                }`}
              />
            </div>
            <div className="flex flex-row gap-[24px]">
              <SelectTab
                key={1}
                selectedTab={year || t("year")}
                setSelectedTab={(newValue: string) => {
                  setYear(newValue);
                }}
                tabs={yearOptions}
                titleLabel={t("house_manager.year")}
              />
              <SelectTab
                key={2}
                selectedTab={status || t("status")}
                setSelectedTab={(newValue: string) => {
                  setStatus(newValue);
                }}
                tabs={statusOptions}
                titleLabel={t("house_manager.status")}
              />
              <div
                className={`${
                  year || status
                    ? "text-[#0027CB] cursor-pointer"
                    : "text-[#00000033] cursor-not-allowed"
                } text-[17px] font-medium flex flex-row items-center`}
                onClick={() => {
                  if (year || status) {
                    setYear(undefined);
                    setStatus(undefined);
                  }
                }}
              >
                {t("house_manager.clean_filter")}{" "}
                <CrossRight className="w-[24px] h-[24px]" />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-[40px]">
            {repairWorks?.results.map((item, index) => {
              return <ProjectItem item={item} index={index} />;
            })}
          </div>

          <Pagination
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            contentLength={repairWorks?.pagination.total_items || 0}
            storageKey="repairWorks"
          />
        </div>
      )}
    </div>
  );
};

export default AddressPage;
